import * as React from "react";
const SvgColorSwatch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M37 51a4 4 0 0 1-4-4V35a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12a4 4 0 0 1-1.172 2.828M37 51a4 4 0 0 0 2.828-1.172M37 51h12a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2.343m-6.829 6.828 8.486-8.485a2 2 0 0 0 0-2.828l-2.829-2.829a2 2 0 0 0-2.828 0L41 37.343M37 47h.01"
    />
  </svg>
);
export default SvgColorSwatch;
